export default [
  {
    path: '/user/apply',
    name: 'ApplyUserList',
    component: () => import('@/views/user/ApplyList.vue')
  },
  {
    path: '/user',
    name: 'UserList',
    component: () => import('@/views/user/UserList.vue')
  },
  {
    path: '/user/:authNo',
    name: 'UserView',
    component: () => import('@/views/user/UserView.vue')
  },
  {
    path: '/user/reset-device-list',
    name: 'ResetDeviceList',
    component: () => import('@/views/user/ResetDeviceList.vue')
  },
  {
    path: '/user/reset-phone-list',
    name: 'ResetPhoneList',
    component: () => import('@/views/user/ResetPhoneList.vue')
  }
];
